import React, { useEffect, useState, useCallback } from 'react';
import { useNavigate, useLocation } from 'react-router-dom';
import $ from 'jquery';
import 'datatables.net';
import Swal from "sweetalert2";
import Select from "react-select";
import { motion, AnimatePresence } from "framer-motion";
import { Helmet } from "react-helmet-async";
import { format } from 'date-fns';


const LaporanAbsensi = () => {
    const location = useLocation(); // Gunakan useLocation untuk membaca query string
    const [isEditing, setIsEditing] = useState(false);

    const queryParams = new URLSearchParams(location.search);

    const id = queryParams.get('id');

    const [dataabsensi, setDataAbsensi] = useState({}); // State untuk menyimpan daftar kelas
    const [error, setError] = useState('');
    const navigate = useNavigate();


    const [targetabsensi, setTargetAbsensi] = useState([]);
    const [kelas, setKelas] = useState([]);

    const [selectAll, setSelectAll] = useState(false);
    const [searchKeyword, setSearchKeyword] = useState("");
    const [loadingtarget, setLoadingtarget] = useState(true);

    const hari = [
        { value: 'Senin', label: 'Senin' },
        { value: 'Selasa', label: 'Selesa' },
        { value: 'Rabu', label: 'Rabu' },
        { value: 'Kamis', label: 'Kamis' },
        { value: 'Jumat', label: 'Jumat' },
        { value: 'Sabtu', label: 'Sabtu' },
        { value: 'Minggu', label: 'Minggu' }
    ];
    const statusaktif = [
        { value: '1', label: 'Aktif' },
        { value: '0', label: 'Tidak Aktif' }
    ];
    const perwakilan = [
        { value: 'Tidak', label: 'Tidak Ada' },
        { value: 'Pd', label: 'Peserta Didik' },
        { value: 'Pendidik', label: 'Pendidik' },
        { value: 'Tendik', label: 'Tendik' },
        { value: 'Pembina', label: 'Pembina' }
    ];
    const tujuan = [
        { value: 'Pendidik', label: 'Pendidik', akses: "Pendidik" },
        { value: 'Pd', label: 'Peserta Didik', akses: "Pd" },
        { value: 'Tendik', label: 'Tendik', akses: "Tendik" },
        { value: 'Pembina', label: 'Pembina', akses: "Pembina" }
    ];
    const pengulangan = [
        { value: 'Sekali', label: 'Sekali' },
        { value: 'Harian', label: 'Harian' }
    ];
    const [formData, setFormData] = useState({
        id_master: id,
        tipe: "Harian",
        nama: "",
        hari: [hari[0].value],
        status: statusaktif[0].value,
        perwakilan: perwakilan[0].value,
        tujuan: tujuan[0].value,
        targetabsensi: [],
        id_rombel: [],
        qrcode:true,
        bukti:true,
        keluar:true,
        buktikegiatan:false,
        lokasi:true,
        keterangan:true
        // jam_mulai:"",
        // jam_selesai:"",
        // jam_keluar:"",
        // batas_jam_keluar:"",
    });
    function formatTanggal(tanggalString) {
        const tanggal = new Date(tanggalString);

        const opsi = { day: 'numeric', month: 'long', year: '2-digit' };
        return new Intl.DateTimeFormat('id-ID', opsi).format(tanggal);
    }
    const getDataRefrensi = useCallback(async () => {
        try {
            // Kirim request ke server dengan header level user
            const response = await fetch(`${process.env.REACT_APP_BASE_URL}/admin/absensi/getmasterabsensibyid?id=${id}`, {
                method: 'GET',
                headers: {
                    'Content-Type': 'application/json',
                    'Authorization': `Bearer ${localStorage.getItem('authToken')}`,
                },
            });

            if (!response.ok) {
                throw new Error("Failed to fetch kelas");
            }

            const data = await response.json();
            console.log(data)
            setDataAbsensi(data.data)
            setTargetAbsensi(data.target);

            setKelas(data.rombel)

        } catch (error) {
            setError(error.message || 'Something went wrong');
        }
    }, []);

    const gettargetAbsensi = useCallback(async () => {
        setLoadingtarget(true)
        try {
            // Kirim request ke server dengan header level user
            const response = await fetch(`${process.env.REACT_APP_BASE_URL}/admin/absensi/gettargetabsensi?akses=${formData.tujuan}`, {
                method: 'GET',
                headers: {
                    'Content-Type': 'application/json',
                    'Authorization': `Bearer ${localStorage.getItem('authToken')}`,
                },
            });

            if (!response.ok) {
                throw new Error("Failed to fetch kelas");
            }

            const data = await response.json();
            console.log(data)
            setTargetAbsensi(data.data);
            setLoadingtarget(false)



        } catch (error) {
            setLoadingtarget(false)
            setError(error.message || 'Something went wrong');
        }
    }, [formData.tujuan]);

    useEffect(() => {
        if (formData.tujuan) {
            gettargetAbsensi();
        }
    }, [formData.tujuan, gettargetAbsensi]);

    useEffect(() => {
        console.log(localStorage.getItem('authToken'))
        getDataRefrensi();
        gettargetAbsensi();
        if ($.fn.dataTable.isDataTable('.datatable-table')) {
            $('.datatable-table').DataTable().destroy();
        }

        $('.datatable-table').DataTable({
            ajax: {
                url: `${process.env.REACT_APP_BASE_URL}/admin/absensi/getdaftarjadwalabsensi?id=${id}`,
                type: "GET",
                headers: {
                    'Content-Type': 'application/json',
                    'Authorization': `Bearer ${localStorage.getItem('authToken')}`,
                },
                dataSrc: function (json) {
                    if (!json.data || json.data.length === 0) {
                        return []; // Jika data kosong, tetap kembalikan array kosong agar DataTables tetap berfungsi
                    }
                    return json.data;
                }
            },
            columns: [
                {
                    data: null,
                    render: function (data, type, row, meta) {
                        return meta.row + 1; // Menampilkan nomor urut
                    }
                },
                {
                    data: null,
                    render: function (data, type, row, meta) {
                        return `<b>${data.nama}</b>`;
                    }
                },
                {
                    data: null,
                    render: function (data, type, row, meta) {
                        let hariArray = [];

                        try {
                            hariArray = JSON.parse(data.hari);
                            if (!Array.isArray(hariArray)) hariArray = [];
                        } catch (e) {
                            hariArray = [];
                        }

                        if (hariArray.length > 0) {
                            const buttons = hariArray.map(hari => `
        <button type="button" class="btn btn-light-primary btn-sm m-1 col">${hari}</button>
      `).join('');

                            return `<div class="row" role="group">${buttons}</div>`;
                        } else {
                            return `<b>${formatTanggal(data.tgl)}</b>`;
                        }
                    }
                },

                {
                    data: null,
                    render: function (data, type, row, meta) {
                        return `<b>${data.jam_mulai} - ${data.jam_keluar || "Tidak Ada"}</b>`;
                    }
                },
                {
                    data: null,
                    render: function (data, type, row, meta) {
                        return ` <a class="btn btn-primary d-inline-flex target-btn" data-row='${JSON.stringify(data.target)}' data-bs-toggle="modal" data-bs-target="#modalDaftarTarget" href="/admin/absensi/viewmasterabsensi?id=${row.id}">
                                <i class="ti ti-manual-gearbox f-20"></i><b>${JSON.parse(data.target).length}</b>
                            </a>`;
                    }
                },
                {
                    data: null,
                    render: function (data, type, row) {

                        return `
                            <a data-bs-toggle="modal" data-bs-target="#ujianModal" class="edit-btn avtar avtar-xs mx-1 btn-link-secondary " data-row='${JSON.stringify(row)}'>
                                <i class="ti ti-edit f-20"></i>
                            </a>
                            <a href="#" class="delete-btn avtar avtar-xs mx-1 btn-link-danger" data-id="${row.id}">
                                <i class="ti ti-trash f-20"></i>
                            </a>
                        `;
                    }
                }
            ],
            destroy: true,
            dom: "<'row'<'col-6 col-sm-6 col-md-9'f><'col-6 col-sm-6 col-md-2 'B><'col-sm-6 col-md-1 float-right'l>><'row'<'col-sm-12'tr>><'row'<'col-sm-12 col-md-10'p><'col-sm-12 col-md-2'i>>",
            language: {
                search: "",
                lengthMenu: "_MENU_",
                emptyTable: "Belum memiliki data", // Pesan jika tidak ada data
                loadingRecords: "Loading....", // Ganti teks "Loading..."
                zeroRecords: "Belum memiliki data yang" // Jika pencarian tidak menemukan hasil
            },
        });


        return () => {
            if ($.fn.dataTable.isDataTable('.datatable-table')) {
                $('.datatable-table').DataTable().destroy();
            }
        };
    }, []);



    $(document).off("click", ".target-btn").on("click", ".target-btn", function () {
        let rowData = $(this).data("row");
        console.log(rowData)
        console.log({ target: JSON.parse(rowData) })
        if (rowData) {

            $('.datatable-target').DataTable({
                ajax: {
                    url: `${process.env.REACT_APP_BASE_URL}/admin/absensi/gettargetbyid`,
                    type: "POST",
                    headers: {
                        'Content-Type': 'application/json',
                        'Authorization': `Bearer ${localStorage.getItem('authToken')}`,
                    },
                    data: function (d) {
                        return JSON.stringify({
                            target: JSON.parse(rowData)
                        });
                    },
                    dataSrc: function (json) {
                        if (!json.data || json.data.length === 0) {
                            return []; // Jika data kosong, tetap kembalikan array kosong agar DataTables tetap berfungsi
                        }
                        return json.data;
                    }
                },
                columns: [
                    {
                        data: null,
                        render: function (data, type, row, meta) {
                            return meta.row + 1; // Menampilkan nomor urut
                        }
                    },
                    {
                        data: null,
                        render: function (data, type, row, meta) {
                            return `<b>${data.nama}</b>`;
                        }
                    },

                    {
                        data: null,
                        render: function (data, type, row) {

                            return `
                                <a href="#" class="hapustargetabsensi avtar avtar-xs mx-1 btn-link-danger" data-id="${row.wa_number}" data-semua="${JSON.parse(rowData)}">
                                    <i class="ti ti-trash f-20"></i>
                                </a>
                            `;
                        }
                    }
                ],
                destroy: true,
                dom: "<'row'<'col-6 col-sm-6 col-md-8'f><'col-6 col-sm-6 col-md-2 'B><'col-sm-6 col-md-2 float-right'l>><'row'<'col-sm-12'tr>><'row'<'col-sm-12 col-md-10'p><'col-sm-12 col-md-2'i>>",
                language: {
                    search: "",
                    lengthMenu: "_MENU_",
                    emptyTable: "Belum memiliki data", // Pesan jika tidak ada data
                    loadingRecords: "Loading....", // Ganti teks "Loading..."
                    zeroRecords: "Belum memiliki data yang" // Jika pencarian tidak menemukan hasil
                },
            });


        } else {
            console.error("Data tidak ditemukan.");
        }
    });

    $(document).on("click", ".hapustargetabsensi", function (e) {
        e.preventDefault();
        let id = $(this).data("id");
        let all = $(this).data("semua");
        let daftartarget = JSON.parse(all)
        daftartarget = daftartarget.filter(item => item !== id);

        Swal.fire({
            title: "Apakah Anda yakin?",
            text: "Data akan dihapus secara permanen!",
            icon: "warning",
            showCancelButton: true,
            confirmButtonColor: "#d33",
            cancelButtonColor: "#3085d6",
            confirmButtonText: "Ya, hapus!",
            cancelButtonText: "Batal"
        }).then((result) => {
            if (result.isConfirmed) {
                console.log({ id: id })

                fetch(`${process.env.REACT_APP_BASE_URL}/admin/absensi/hapustarget`, {
                    method: "POST",
                    headers: {
                        "Content-Type": "application/json",
                        "Authorization": `Bearer ${localStorage.getItem('authToken')}`
                    },
                    body: JSON.stringify({ id: id, target: daftartarget })
                })
                    .then(response => response.json())
                    .then(data => {
                        if (data.success) {
                            Swal.fire("Terhapus!", "Data berhasil dihapus.", "success");
                            $('.table').DataTable().ajax.reload(); // Reload DataTable setelah hapus
                        } else {
                            Swal.fire("Gagal!", data.message, "error");
                        }
                    })
                    .catch(error => {
                        Swal.fire("Error!", "Terjadi kesalahan saat menghapus data.", "error");
                    });
            }
        });
    });

    const handleChange = (e) => {
        const { name, value } = e.target;
        let selectedText = "";
        if (name === "kode" || name === "data_id") {
            selectedText = e.target.options[e.target.selectedIndex].text;
        }


        setFormData((prevData) => ({
            ...prevData,
            [name]: value,
            ...(name === "kode" && { nama_ujian: selectedText }),
            ...(name === "data_id" && { nama_guru: selectedText })
        }));
        console.log(formData)
    };
    const handleSubmit = async (e) => {
        e.preventDefault();
        console.log({
            ...formData,
            tgl: formData.tipe == "Harian" ? null : formData.tgl
        })
        try {
            const response = await fetch(`${process.env.REACT_APP_BASE_URL}/admin/absensi/inputjawdal`, {
                method: "POST",
                headers: {
                    "Content-Type": "application/json",
                    "Authorization": `Bearer ${localStorage.getItem('authToken')}`,
                },
                body: JSON.stringify({
                    ...formData,
                    tgl: formData.tipe == "Harian" ? null : formData.tgl
                }),
            });

            const result = await response.json();
            console.log(result.message);
            if (!response.ok) {
                Swal.fire("Error!", "Terjadi kesalahan saat menyimpan jadwal.", "error");
            } else {
                $('.table-data').DataTable().ajax.reload(null, false);
                Swal.fire("Berhasil!", "Jadwal berhasil disimpan!", "success");
                document.getElementById('btnTutupModal').click();
            }

        } catch (error) {
            console.error("Terjadi kesalahan:", error);
            Swal.fire("Error!", "Terjadi kesalahan saat menyimpan jadwal.", "error");
        }

    };

    const handleSelectAll = () => {
        if (selectAll) {
            setFormData({
                ...formData,
                targetabsensi: []
            }); // kosongkan kalau uncheck
        } else {
            setFormData({
                ...formData,
                targetabsensi: targetabsensi.map(item => item.wa_number)
            })

        }
        setSelectAll(!selectAll);
    };

    // Toggle per item
    const handleSelectItem = (wa_number) => {
        if (formData.targetabsensi.includes(wa_number)) {
            setFormData({
                ...formData,
                targetabsensi: formData.targetabsensi.filter(item => item !== wa_number)
            })
        } else {

            setFormData({
                ...formData,
                targetabsensi: [...formData.targetabsensi, wa_number]
            })

        }
    };

    const filteredAbsensi = targetabsensi.filter(item =>
        (item.nama?.toLowerCase() || '').includes(searchKeyword.toLowerCase()) ||
        (item.data_id?.toLowerCase() || '').includes(searchKeyword.toLowerCase())
    );
    return (
        <>
            <Helmet>
                <title>Detail Master Absensi</title>
            </Helmet>
            <div>
                <div className="pc-container">
                    <div className="pc-content">
                        <div className="row">
                            <div className="col-xl-12 col-md-12">
                                <div className="card flat-card">

                                    <div className="row-table">

                                        <div className="col-sm-4 card-body w-50 br">
                                            <div className="row g-1">
                                                <div className="col-4">
                                                    <div className="b-icons bg-light-primary">
                                                        <i className="ti ti-friends text-secondary"></i>
                                                    </div>
                                                </div>
                                                <div className="col-8 text-md-center">

                                                    <span className="text-muted">Nama</span>
                                                    <h5>{dataabsensi.nama}</h5>
                                                </div>
                                            </div>
                                        </div>

                                        <div className="col-sm-4 card-body w-50 br">
                                            <div className="row g-1">
                                                <div className="col-4">
                                                    <div className="b-icons bg-light-primary">
                                                        <i className="ti ti-friends text-secondary"></i>
                                                    </div>
                                                </div>
                                                <div className="col-8 text-md-center">

                                                    <span className="text-muted">kategori</span>
                                                    <h5>{dataabsensi.kategori}</h5>
                                                </div>
                                            </div>
                                        </div>
                                        <div className="col-sm-12 card-body w-50 br">
                                            <div className="row g-1">
                                                <div className="col-4">
                                                    <div className="b-icons bg-light-primary">
                                                        <i className="ti ti-friends text-secondary"></i>
                                                    </div>
                                                </div>
                                                <div className="col-8 text-md-center">

                                                    <span className="text-muted">Deskripsi</span>
                                                    <h5>{dataabsensi.deskripsi}</h5>
                                                </div>
                                            </div>
                                        </div>
                                    </div>

                                    <div className="row-table">

                                        <div className="col-sm-12 card-body w-50 br">
                                            <div className="row g-1">
                                                <div className="col-4">
                                                    <div className="b-icons bg-light-primary">
                                                        <i className="ti ti-friends text-secondary"></i>
                                                    </div>
                                                </div>
                                                <div className="col-8 text-md-center">

                                                    <span className="text-muted">Status</span>
                                                    <h5>{dataabsensi.aktif}</h5>
                                                </div>
                                            </div>
                                        </div>
                                        <div className="col-sm-12 card-body w-50 br">
                                            <div className="row g-1">
                                                <div className="col-4">
                                                    <div className="b-icons bg-light-primary">
                                                        <i className="ti ti-friends text-secondary"></i>
                                                    </div>
                                                </div>
                                                <div className="col-8 text-md-center">


                                                    <a href={`/pendidik/viewevaluasi?id_ujian=${dataabsensi.id}`} className="btn btn-primary d-inline-flex"><i className='ti ti-file-invoice'></i> Laporan</a>
                                                </div>
                                            </div>
                                        </div>
                                    </div>
                                    <hr />
                                </div>
                            </div>
                        </div>

                        <div className="col-xl-12 col-md-12">
                            <div className="card">

                                <div className="card-body">
                                    <div className='row mb-3 align-items-center'>
                                        <div className="col"><small className="text-muted">Absensi</small><h3>Jadwal Absensi</h3></div>

                                        <div className='col-auto'>
                                            <button data-bs-toggle="modal" data-bs-target="#ujianModal" type="button" className="btn btn-primary d-inline-flex"><i className="ti ti-plus me-1"></i>Tambah Jadwal</button>
                                        </div>
                                    </div>
                                    <hr />
                                    {/* Tabel kelas */}
                                    <table className="table table-data table-hover datatable-table">
                                        <thead>
                                            <tr>
                                                <th width="50">#</th>
                                                <th scope="col">Nama</th>
                                                <th scope="col">Tanggal / Hari</th>
                                                <th scope="col">Jam Masuk / Keluar</th>
                                                <th scope="col">Target</th>
                                                <th scope="col">Action</th>
                                            </tr>
                                        </thead>

                                    </table>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
            </div>


            <div className="modal fade" id="ujianModal" tabIndex="-1" aria-hidden="true">
                <div className="modal-dialog modal-lg">
                    <form onSubmit={handleSubmit} className="modal-content">
                        <div className="modal-header">
                            <h5 className="modal-title">{isEditing ? "Edit Jadwal" : "Tambah Jadwal"}</h5>
                            <button type="button" className="btn-close" data-bs-dismiss="modal" id='btnTutupModal' aria-label="Close"></button>
                        </div>
                        <div className="modal-body">
                            <div className="mb-3">
                                <label className="form-label">Nama</label>
                                <input type="text" className="form-control" name="nama" value={formData.nama} onChange={handleChange} required />

                            </div>

                            <div class="row ">
                                <div class="col-lg-12">
                                    <div class="border card p-3">
                                        <div class="form-check">
                                            <input type="radio" name="tipe" checked={formData.tipe == "Harian" ? true : false} value={"Harian"} class="form-check-input input-primary" id="customCheckdef2"
                                                onChange={(selectedDays) => {
                                                    setFormData({
                                                        ...formData,
                                                        tipe: selectedDays.target.value
                                                    });
                                                }} />
                                            <label class="form-check-label d-block" for="customCheckdef2">
                                                <span>
                                                    <span class="h5 d-block">
                                                        Harian </span>
                                                    <span class="f-12 text-muted">Dilakukan pada hari yang ditentukan dan berulang setiap minggu-nya</span>

                                                </span>
                                            </label>
                                        </div>
                                    </div>
                                </div>
                                <div class="col-lg-12">
                                    <div class="border card p-3">
                                        <div class="form-check">
                                            <input type="radio" checked={formData.tipe == "Sekali" ? true : false} name="tipe" value={"Sekali"}
                                                onChange={(selectedDays) => {
                                                    setFormData({
                                                        ...formData,
                                                        tipe: selectedDays.target.value
                                                    });
                                                }} class="form-check-input input-primary" id="customCheckdef1" />
                                            <label class="form-check-label d-block" for="customCheckdef1">
                                                <span>
                                                    <span class="h5 d-block">
                                                        Sekali </span>
                                                    <span class="f-12 text-muted">Dilakukan pada tanggal tertentu dan tidak berulang</span>
                                                </span>
                                            </label>
                                        </div>
                                    </div>
                                </div>
                                <AnimatePresence>
                                    {formData.tipe === 'Harian' && (
                                        <motion.div
                                            className="mb-3"
                                            initial={{ opacity: 0, y: -10 }}
                                            animate={{ opacity: 1, y: 0 }}
                                            exit={{ opacity: 0, y: -10 }}
                                            transition={{ duration: 0.3 }}
                                        >
                                            <label className="form-label">Hari</label>
                                            <Select
                                                options={hari}
                                                isMulti
                                                required
                                                name="hari"
                                                getOptionLabel={(e) => e.label}
                                                getOptionValue={(e) => e.value}
                                                value={hari.filter(option => formData.hari.includes(option.value))}
                                                onChange={(selectedDays) => {
                                                    setFormData({
                                                        ...formData,
                                                        hari: selectedDays.map((day) => day.value),
                                                        tgl: ""
                                                    });
                                                }}
                                                placeholder="Pilih Hari..."
                                            />
                                        </motion.div>
                                    )}
                                </AnimatePresence>
                                <AnimatePresence>
                                    {formData.tipe === 'Sekali' && (
                                        <motion.div
                                            className="mb-3"
                                            initial={{ opacity: 0, y: -10 }}
                                            animate={{ opacity: 1, y: 0 }}
                                            exit={{ opacity: 0, y: -10 }}
                                            transition={{ duration: 0.3 }}
                                        >
                                            <label className="form-label">Tanggal</label>
                                            <input
                                                type="date"
                                                className="form-control"
                                                name="tgl"
                                                value={formData.tgl}
                                                onChange={(e) => setFormData({ ...formData, tgl: e.target.value, hari: "" })}
                                                required
                                            />
                                        </motion.div>
                                    )}
                                </AnimatePresence>
                            </div>
                            <div className='row mb-3'>
                                <div className="col ">
                                    <label className="form-label">Jam Masuk</label>
                                    <input name='jam_mulai' className="form-control" type="time" placeholder="Jam Masuk" value={formData.jam_mulai} onChange={handleChange} required />
                                </div>
                                <div className="col ">
                                    <label className="form-label">Batas Jam Masuk</label>
                                    <input name='jam_selesai' className="form-control" type="time" placeholder="Jam Selesai" value={formData.jam_selesai} onChange={handleChange} required />
                                </div>
                            </div>

                            <div className='row mb-3'>
                                <div className="col ">
                                    <label className="form-label">Jam Keluar</label>
                                    <input name='jam_keluar' className="form-control" type="time" placeholder="Jam Keluar" value={formData.jam_keluar} onChange={handleChange} />
                                </div>

                                <div className="col">
                                    <label className="form-label">Batas Jam Keluar</label>
                                    <input name='batas_jam_keluar' className="form-control" type="time" placeholder="Batas Jam Keluar" value={formData.batas_jam_keluar} onChange={handleChange} />
                                </div>
                            </div>

                            <div className="mb-3 ">
                                <label className="form-label"><b>Tujuan</b></label>

                                <div class="row ">
                                    {tujuan.map((item, index) => (
                                        <div class="col">
                                            <div class="border card p-3">
                                                <div class="form-check">
                                                    <input type="radio" name="tujuan" checked={formData.tujuan == item.value ? true : false} value={item.value} class="form-check-input input-primary" id={item.value}
                                                        onChange={(selectedDays) => {
                                                            setFormData({
                                                                ...formData,
                                                                tujuan: selectedDays.target.value
                                                            });

                                                        }} />
                                                    <label class="form-check-label d-block" for={item.value}>
                                                        <span>
                                                            <span class="h5 d-block">
                                                                {item.label} </span>

                                                        </span>
                                                    </label>
                                                </div>
                                            </div>
                                        </div>
                                    ))}
                                </div>
                            </div>
                            <div className="mb-3 ">
                                <label className="form-label">
                                    <input checked={selectAll} onChange={handleSelectAll} className="form-check-input input-light-secondary" type="checkbox" /> All :  Target Absensi</label>
                                <div className="mb-2">
                                    <input
                                        type="text"
                                        className="form-control"
                                        placeholder="Cari nama atau ID..."
                                        value={searchKeyword}
                                        onChange={(e) => setSearchKeyword(e.target.value)}
                                    />
                                </div>
                                <div className="table-responsive" style={{ height: 500 }}>
                                    <ul className='list-group list-group-flush' style={{ margin: 0, padding: 0 }}>
                                        {loadingtarget ? (
                                            <li className="list-group-item text-center">
                                                <div class="spinner-border" style={{ width: "3rem", height: "3rem" }} role="status"><span class="sr-only">Loading...</span></div>
                                            </li>
                                        ) : (
                                            <>  {filteredAbsensi.map((item, index) => (

                                                <li className="list-group-item px-0" key={"d" + index}>
                                                    <div className="d-flex align-items-center">
                                                        <div className="flex-shrink-0">
                                                            <input
                                                                className="form-check-input input-light-secondary"
                                                                type="checkbox"
                                                                id={item.wa_number}
                                                                checked={formData.targetabsensi.includes(item.wa_number)}
                                                                onChange={() => handleSelectItem(item.wa_number)}
                                                            />
                                                            <label className="form-check-label" htmlFor={item.wa_number}></label>
                                                        </div>
                                                        <div className="flex-grow-1 ms-3">
                                                            <div className="row g-1">
                                                                <div className="col-12">
                                                                    <h6 className="mb-0">{item.nama}</h6>
                                                                    <p className="text-muted mb-0"><small>{item.data_id}</small></p>
                                                                </div>
                                                            </div>
                                                        </div>
                                                    </div>
                                                </li>

                                            ))} </>)}

                                        {filteredAbsensi.length === 0 && (
                                            <li className="list-group-item text-center text-muted">Data tidak ditemukan.</li>
                                        )}
                                    </ul>
                                </div>
                            </div>
                            <div className="mb-3">
                                <label className="form-label">Melakukan Absensi Kepada</label>
                                <Select
                                    options={kelas}
                                    isMulti
                                    name="id_rombel"
                                    getOptionLabel={(e) => e.nama_rombel} // Menampilkan nama di dropdown
                                    getOptionValue={(e) => e.rombel_id} // Menggunakan id_rombel sebagai value
                                    value={
                                        Array.isArray(kelas) && Array.isArray(formData?.id_rombel)
                                            ? kelas.filter((option) =>
                                                formData.id_rombel.some((d) => d === option.rombel_id)
                                            )
                                            : []
                                    }
                                    onChange={(kelasTerpilih) => {
                                        setFormData({
                                            ...formData,
                                            id_rombel: kelasTerpilih.map((item) => item.rombel_id)
                                        });
                                        console.log(formData)
                                    }}
                                    placeholder="Kosongkan Jika Tidak Ada..."
                                />


                            </div>

                            <div className="mb-3">
                                <label className="form-label">Aktif</label>
                                <Select
                                    options={statusaktif}
                                    required
                                    name="status"
                                    getOptionLabel={(e) => e.label} // Menampilkan nama di dropdown
                                    getOptionValue={(e) => e.value} // Menggunakan id_rombel sebagai value
                                    value={statusaktif?.find((option) => option.value?.toString() === formData?.status?.toString()) || null}
                                    onChange={(statusaktif) => {
                                        setFormData({
                                            ...formData,
                                            status: statusaktif.value
                                        })
                                    }}
                                    placeholder="Pilih Status..."
                                />
                            </div>

                            <div className="mb-3 ">
                                <label className="form-label"><b>Pengaturan Tambahan</b></label>
                                <div class="form-check form-switch">
                                    <input type="checkbox" class="form-check-input" id="qrcode"
                                      checked={formData.qrcode}
                                        onChange={(e) => {
                                        setFormData({
                                            ...formData,
                                            qrcode: e.target.checked, // true jika dicentang, false jika tidak
                                        });
                                        }}
                                    /> 
                                    <label class="form-check-label" for="qrcode">Absen Keluar</label>
                                </div>

                                <div class="form-check form-switch">
                                    <input type="checkbox" class="form-check-input" id="keluar"
                                      checked={formData.keluar}
                                        onChange={(e) => {
                                        setFormData({
                                            ...formData,
                                            keluar: e.target.checked, // true jika dicentang, false jika tidak
                                        });
                                        }}
                                    /> 
                                    <label class="form-check-label" for="keluar">QRCODE</label>
                                </div>

                                <div class="form-check form-switch">
                                    <input type="checkbox" class="form-check-input" id="Bukti Absensi"
                                    checked={formData.bukti}
                                        onChange={(e) => {
                                        setFormData({
                                            ...formData,
                                            bukti: e.target.checked, // true jika dicentang, false jika tidak
                                        });
                                        }}
                                    /> 
                                    <label class="form-check-label" for="Bukti Absensi">Bukti Absensi</label>
                                </div>
                                <div class="form-check form-switch">
                                    <input type="checkbox" class="form-check-input" id="Bukti Kegiatan"
                                    checked={formData.buktikegiatan}
                                        onChange={(e) => {
                                        setFormData({
                                            ...formData,
                                            buktikegiatan: e.target.checked, // true jika dicentang, false jika tidak
                                        });
                                        }}
                                    /> 
                                    <label class="form-check-label" for="Bukti Kegiatan">Bukti Kegiatan</label>
                                </div>
                                 <div class="form-check form-switch">
                                    <input type="checkbox" class="form-check-input" id="Lokasi"
                                    checked={formData.lokasi}
                                        onChange={(e) => {
                                        setFormData({
                                            ...formData,
                                            lokasi: e.target.checked, // true jika dicentang, false jika tidak
                                        });
                                        }}
                                    /> 
                                    <label class="form-check-label" for="Lokasi">Lokasi</label>
                                </div>
                                <div class="form-check form-switch">
                                    <input type="checkbox" class="form-check-input" id="Keterangan"
                                     checked={formData.keterangan}
                                        onChange={(e) => {
                                        setFormData({
                                            ...formData,
                                            keterangan: e.target.checked, // true jika dicentang, false jika tidak
                                        });
                                        }}
                                    /> 
                                    <label class="form-check-label" for="Keterangan">Keterangan</label>
                                </div>
                            </div>
                        </div>
                        <div className="modal-footer">
                            <button type="button" className="btn btn-secondary" data-bs-dismiss="modal">
                                Batal
                            </button>
                            <button type='submit' className="btn btn-primary">
                                {isEditing ? "Update" : "Simpan"}
                            </button>
                        </div>
                    </form>
                </div>
            </div>

            <div className="modal fade" id="modalDaftarTarget" tabIndex="-1" aria-hidden="true">
                <div className="modal-dialog modal-lg">
                    <form onSubmit={handleSubmit} className="modal-content">
                        <div className="modal-header">
                            <h5 className="modal-title">Daftar Target Absensi </h5>
                            <button type="button" className="btn-close" data-bs-dismiss="modal" id='btnTutupModal' aria-label="Close"></button>
                        </div>
                        <div className="modal-body">
                            <table className="table table-hover datatable-target">
                                <thead>
                                    <tr>
                                        <th width="50">#</th>
                                        <th scope="col">Nama</th>
                                        <th width="50">Action</th>
                                    </tr>
                                </thead>

                            </table>
                        </div>
                    </form>

                </div>
            </div>
        </>
    );
};

export default LaporanAbsensi;
